export default "__VITE_ASSET__a572ca3c__"